const lineHeights = [1, 1.5]

export default lineHeights
